var API_DOMAIN = "https://demobilling.zentexus.com/api";

export default API_DOMAIN;
